import fetch from '../../utils/fetch.js'
/**
 * 参数配置列表
 */
export function canteenConfigList (data) {
  return fetch({
    url: '/admin/canteen-config/index',
    method: 'get',
    params: data
  })
}
/**
 * 参数配置详情
 */
export function canteenConfigInfo (data) {
  return fetch({
    url: '/admin/canteen-config/info',
    method: 'get',
    params: data
  })
}
/**
 * 保存参数
 */
export function canteenConfigSave (data) {
  return fetch({
    url: '/admin/canteen-config/save',
    method: 'post',
    data
  })
}
/**
 * 后台用户列表
 */
export function authUserList (data) {
  return fetch({
    url: '/admin/auth/user/index',
    method: 'get',
    params: data
  })
}
/**
 * 后台用户详情
 */
export function authUserinfo (data) {
  return fetch({
    url: '/admin/auth/user/info',
    method: 'get',
    params: data
  })
}
/**
 * 保存后台用户
 */
export function saveAuthUser (data) {
  return fetch({
    url: '/admin/auth/user/save',
    method: 'post',
    data
  })
}
/**
 * 删除后台用户
 */
export function delAuthUser (data) {
  return fetch({
    url: '/admin/auth/user/delete',
    method: 'get',
    params: data
  })
}
/**
 * 后台角色列表
 */
export function authRoleList (data) {
  return fetch({
    url: '/admin/auth/role/index',
    method: 'get',
    params: data
  })
}
/**
 * 删除后台角色
 */
export function delAuthRole (data) {
  return fetch({
    url: '/admin/auth/role/delete',
    method: 'get',
    params: data
  })
}
/**
 * 保存后台角色
 */
export function saveAuthRole (data) {
  return fetch({
    url: '/admin/auth/role/save',
    method: 'post',
    data
  })
}
/**
 * 获取后台角色
 */
export function authRoleInfo (data) {
  return fetch({
    url: '/admin/auth/role/info',
    method: 'get',
    params: data
  })
}
/**
 * 获取后台权限树
 */
export function authPermissionTree (data) {
  return fetch({
    url: '/admin/auth/permission/tree',
    method: 'get',
    params: data
  })
}
/**
 * 保存后台权限
 */
export function saveAuthPermission (data) {
  return fetch({
    url: '/admin/auth/permission/save',
    method: 'post',
    data
  })
}
/**
 * 删除后台权限
 */
export function delAuthPermission (data) {
  return fetch({
    url: '/admin/auth/permission/delete',
    method: 'get',
    params: data
  })
}
/**
 * 根据ID查询权限
 */
export function authPermissionById (data) {
  return fetch({
    url: '/admin/auth/permission/info',
    method: 'get',
    params: data
  })
}
/**
 * 获取后台菜单权限树
 */
export function menuPermissionTree (data) {
  return fetch({
    url: '/admin/auth/menu/tree',
    method: 'get',
    params: data
  })
}
/**
 * 删除后台菜单权限树
 */
export function delMenuPermissionTree (data) {
  return fetch({
    url: '/admin/auth/menu/delete',
    method: 'get',
    params: data
  })
}
/**
 * 根据ID后台菜单权限
 */
export function menuPermissionInfo (data) {
  return fetch({
    url: '/admin/auth/menu/info',
    method: 'get',
    params: data
  })
}
/**
 * 保存后台菜单权限
 */
export function menuPermissionSave (data) {
  return fetch({
    url: '/admin/auth/menu/save',
    method: 'post',
    data
  })
}
/**
 * 根据用户ID获取菜单
 */
export function getUserMenu (data) {
  return fetch({
    url: '/admin/auth/menu/list',
    method: 'get',
    params: data
  })
}

/**
 * 修改后台用户列表密码
 */
export function updatePass (data) {
  return fetch({
    url: '/admin/auth/user/password',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/authManage/auth.js